import { useMsal } from '@azure/msal-react';
import {
    Button,
    Container,
    Grid,
    Typography,
} from '@material-ui/core'
import React, { ReactElement, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getMessstellenForLookup } from '../../../features/messstellenLookup/messstellenLookupSlice';
import {
    getGruppen,
    selectEditMode,
    selectNewMode
} from './gruppenverwaltungSlice';
import { GruppenverwaltungEdit } from './edit';
import { GruppenverwaltungGrid } from './grid';
import { Gruppenauswahl } from './gruppenauswahl';
import CachedIcon from '@material-ui/icons/Cached';

export default function Gruppenverwaltung(): ReactElement {
    const dispatch = useAppDispatch();
    const { instance } = useMsal();
    const [reload, setReload] = React.useState(false)


    useEffect(() => {
        dispatch(getGruppen());
        dispatch(getMessstellenForLookup());
    }, [instance, reload]);

    const editMode = useAppSelector(selectEditMode);
    const newMode = useAppSelector(selectNewMode);

    return (
        <div>
            <Container maxWidth={false} style={{ marginTop: "10px" }}>
                <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item md={3} />
                    <Grid item md={6}>
                        <Typography color="primary" variant="h5">
                            Gruppenverwaltung
                        </Typography>
                    </Grid>
                    <Grid item md={12} >
                  <Grid item md={12} style={{ textAlignLast: "right", marginTop: "-24px", marginBottom: "16px" }}>
                    <Button color="secondary" 
                    onClick={() => setReload(!reload)}>Neu Laden<CachedIcon style={{marginLeft: "10px"}}/></Button >
                  </Grid> 
                </Grid>
                </Grid>
            </Container>
            {(newMode || editMode) ? <GruppenverwaltungEdit /> : ""}
            <Gruppenauswahl />
            <GruppenverwaltungGrid />
        </div>
    );
}

